import './CaseResolutionShow.scss';

import { RefreshButton, Show } from '@refinedev/antd';
import { useResourceParams } from '@refinedev/core';

import CaseResolutionPackageItems from './CaseResolutionShow/CaseResolutionItem/CaseResolutionPackageItems';
import CaseResolutionShowDetail from './CaseResolutionShow/CaseResolutionShowDetail';
import useCaseResolutionShow from './useCaseResolutionShow';

const CaseResolutionShow = () => {
  const { id } = useResourceParams();
  const {
    loadingData,
    ticket,
    shipments,
    receptions,
    serviceOrders,
    logisticCompanies,
    paymentCompanies,
    packageItems,
    serviceOrderItems,
    refetch,
  } = useCaseResolutionShow(id);

  return (
    <Show
      title={'Resolución de caso #' + id}
      isLoading={loadingData}
      headerButtons={({ refreshButtonProps }) => (
        <RefreshButton {...refreshButtonProps} onClick={() => void refetch()} />
      )}>
      <div className="CaseResolutionShow">
        <CaseResolutionShowDetail
          ticket={ticket}
          shipments={shipments}
          receptions={receptions}
          serviceOrders={serviceOrders}
          logisticCompanies={logisticCompanies}
          paymentCompanies={paymentCompanies}
          refetch={refetch}
        />
        <CaseResolutionPackageItems
          packageItems={packageItems}
          serviceOrderItems={serviceOrderItems}
          refetch={refetch}
        />
      </div>
    </Show>
  );
};

export default CaseResolutionShow;
